import React from "react";

import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import { Column } from "@rui/Stack";
import TextField, { TextFieldProps } from "@rui/TextField";

const StyledInputLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.shades.neutral[500],
  fontSize: "0.93rem",
  fontFamily: "sans-serif",
}));

const StyledTextField = styled(TextField)({
  "& input": {
    color: "rgb(101,101,101)",
    fontFamily: "sans-serif",
    padding: "0.75rem",
    transition:
      "background 0.15s ease, border 0.15s ease, box-shadow 0.15s ease, color 0.15s ease",
    boxShadow:
      "0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02)",
    lineHeight: "1.15rem",
    maxHeight: "20px",
  },
  "& .MuiOutlinedInput-root:hover:not(.Mui-focused):not(.Mui-disabled)>.MuiOutlinedInput-notchedOutline":
    {
      border: "1px solid #e6e6e6",
    },
  "& fieldset.MuiOutlinedInput-notchedOutline": {
    border: "1px solid #e6e6e6",
  },
  "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "1px solid hsla(242, 57%, 54%, 50%) !important",
    boxShadow:
      "0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02), 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02),  0 0 0 3px hsla(242, 57%, 54%, 25%), 0px 1px 1px 0 rgba(0, 0, 0, 0.08)",
  },
});

const StripeFormField = React.forwardRef(
  ({ label, ...props }: TextFieldProps, ref) => {
    return (
      <Column spacing={0.5}>
        <StyledInputLabel>{label}</StyledInputLabel>
        <StyledTextField {...props} ref={ref} />
      </Column>
    );
  }
);

StripeFormField.displayName = "StripeFormField";

export default StripeFormField;
